import React from 'react';
import { Line } from 'react-chartjs-2';

const FeeCollectionChart = () => {
  const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
    datasets: [
      {
        label: 'Fee Collection',
        data: [5000, 7000, 6000, 8000, 7500],
        backgroundColor: 'rgba(255, 206, 86, 0.5)',
        borderColor: 'rgba(255, 206, 86, 1)',
        fill: true,
      },
    ],
  };

  return <Line data={data} />;
};

export default FeeCollectionChart;
